/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_TypeInputs */

const en_admin_questionnaire_editor_type = /** @type {(inputs: Admin_Questionnaire_Editor_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_TypeInputs) => LocalizedString} */
const de_admin_questionnaire_editor_type = en_admin_questionnaire_editor_type;

/** @type {(inputs: Admin_Questionnaire_Editor_TypeInputs) => LocalizedString} */
const es_admin_questionnaire_editor_type = en_admin_questionnaire_editor_type;

/** @type {(inputs: Admin_Questionnaire_Editor_TypeInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_type = en_admin_questionnaire_editor_type;

/** @type {(inputs: Admin_Questionnaire_Editor_TypeInputs) => LocalizedString} */
const it_admin_questionnaire_editor_type = en_admin_questionnaire_editor_type;

/** @type {(inputs: Admin_Questionnaire_Editor_TypeInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_type = en_admin_questionnaire_editor_type;

/** @type {(inputs: Admin_Questionnaire_Editor_TypeInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_type = en_admin_questionnaire_editor_type;

/** @type {(inputs: Admin_Questionnaire_Editor_TypeInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_type = en_admin_questionnaire_editor_type;

/** @type {(inputs: Admin_Questionnaire_Editor_TypeInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_type = en_admin_questionnaire_editor_type;

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Admin_Questionnaire_Editor_TypeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_type = /** @type {((inputs?: Admin_Questionnaire_Editor_TypeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_TypeInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_type(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_type(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_type(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_type(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_type(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_type(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_type(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_type(inputs)
	return ro_admin_questionnaire_editor_type(inputs)
});
export { admin_questionnaire_editor_type as "admin.questionnaire_editor.type" }